class Form
{
    constructor() {
        this.svobodaStola();
        this.selectionCallback();
        this.addBar();
        setTimeout(this.review);
    }

    svobodaStola(sourceBtn) {
        let countdownEl = $('#svobodastola-countdown-number'),
            countdown = 3,
            duration = 250,
            step1 = $('#svobodastola-step-1'),
            step2 = $('#svobodastola-step-2'),
            step3 = $('#svobodastola-step-3'),
            interval = setInterval(() => {
                countdownEl.text(--countdown || 0)

                if (! countdown) {
                    clearInterval(interval)
                    step1.hide(duration, () => step2.show(duration).parent().processBronForm(sourceBtn))
                }
            }, 1000)

        countdownEl.text(countdown)

        step2.find('button:not([type=button])').on('click', () => {
            step2.hide(duration, () => step3.show(duration, () => $app.runEvent('stol-click-step2')))

            return false
        })
    }

    review() {
        let form = $('#review-form'),
            list = $('#review-list')

        form.easyValidate((json, button) => {
            list.prepend(json.opinion).find('select').barrating({ readonly: true })

            button.parent().remove()

            $app.runEvent('opinion-submit', form.data('id'))

            document.querySelector('.bar__tab--selected')?.scrollIntoView({ behavior: 'smooth' })
        }, json => {
            if (json.needAuth) {
                $.fancybox.open(json.msg)
            } else {
                return swal.fire('Ошибка :(', json.msg, 'error')
            }
        }).find('select').barrating({ showSelectedRating: $app.isMobile })

        list.find('select').each((i, select) => {
            $(select).barrating({ readonly: true })

            select.nextElementSibling.lastElementChild.textContent = select.dataset.value
        })

        $('.load-review-detail:not(.tooltipstered)').tooltipster({
            interactive: true,
            contentAsHTML: true,
            content: 'Загрузка...',
            functionBefore: (instance, helper) => {
                let origin = $(helper.origin);

                if (origin.data('loaded') !== true) {
                    $.get(origin.data('url'), ({list}) => {
                        instance.content(list);
                        origin.data('loaded', true);

                        $app.runEvent('hover', { 'review-detail' : origin.data('event') });
                    });
                }
            }
        });
    }

    selectionCallback() {
        $('#selection-callback').easyValidate((json, btn) => {
            btn.remove()
            swal.fire('Отлично!', json.msg, 'success')
            $app.runEvent('click', 'selection-callback-submit')
        })
    }

    addBar() {
        $('#add-bar').easyValidate(json => {
            $app.runEvent('click', 'add-bar-submit');

            if (json.ret) {
                swal.fire('Отлично!', json.msg, 'success').then(() => $.fancybox.getInstance().close());
            } else {
                swal.fire('Ошибка :(', json.msg, 'error');
            }
        });
    }

    chooseTable(form) {
        $.get('/bar/bron/getTableMap', { id: form.data('id') }, response => {
            swal.fire({
                padding: '0',
                html: response.map,
                width: 'fit-content',
                showCloseButton: true,
                showConfirmButton: false,
                onOpen(content) {
                    content.querySelector('map').addEventListener('click', event => {
                        let table = event.target.href.split('#')[1],
                            comment = form.find('.bron-extended-toggle').removeClass('d-none').find('textarea');

                        comment.val('Столик №' + table + "\n" + comment.val().replace(/Столик №\d+\s?/gi, ''));

                        swal.close();
                    });

                    content.classList.add('overflow-auto');
                    swal.getContent().classList.add('overflow-auto');

                    setTimeout(() => {
                        $(swal.getContent()).animate({
                            scrollLeft: (($('section:first', content).width() - $(content).width()) / 2) + 'px'
                        });
                    }, 1000);
                }
            });
        });

        return false;
    }
}

module.exports = Form;